import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Products from './Products.vue'
import Customers from './Customers.vue'
import GroupedProducts from './GroupedProducts.vue'
import Dashboard from './Dashboard.vue'
import { VuejsDatatableFactory } from 'vuejs-datatable'
import VueGoodTablePlugin from 'vue-good-table'

import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor, /* { default global options } */)

import VueAutosuggest from "vue-autosuggest";
Vue.use(VueAutosuggest);

Vue.use( VuejsDatatableFactory )

import 'vue-good-table/dist/vue-good-table.css'

Vue.use(VueGoodTablePlugin);

Vue.config.productionTip = false
Vue.use(VueRouter)


const routes = [
  { path: '/customers', component: Customers},
  { path: '/products', component: Products},
  { path: '/grouped-products', component: GroupedProducts},
  { path: '/', component: Dashboard}
];

const router = new VueRouter({
  routes: routes,
  mode: 'history'
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
